"use client";

import { dateFormatYYYYMMDD } from "../../../../../../lib/utils/dates/dateFormatYYYYMMDD";
import type { UseOpenApiQueryOptions } from "../../../../../../request/hooks/openApi/useOpenApiQuery";
import { useOpenApiQuery } from "../../../../../../request/hooks/openApi/useOpenApiQuery";
import { keyCommunitiesStatsTotals } from "./keyCommunitiesStatsTotals";

const urlBackendPath = "/communities/{community_id}/stats/totals" as const;

export type UseRequestCommunitiesStatsTotalsProps = Omit<
  UseOpenApiQueryOptions<typeof urlBackendPath>,
  "urlBackendPath" | "params" | "queryKey"
> & {
  endDate?: Date;
  id: number;
  startDate?: Date;
};

export const useRequestCommunitiesStatsTotals = ({
  endDate,
  id,
  startDate,
  ...props
}: UseRequestCommunitiesStatsTotalsProps) => ({
  query: useOpenApiQuery({
    ...props,
    urlBackendPath,
    params: {
      path: { community_id: id },
      query: {
        ...(startDate
          ? { start_date: dateFormatYYYYMMDD({ date: startDate }) }
          : {}),
        ...(endDate ? { end_date: dateFormatYYYYMMDD({ date: endDate }) } : {}),
      },
    },
    queryKey: keyCommunitiesStatsTotals({ endDate, id, startDate }),
  }),
});
